// @core/api/endpoints/localization/get_locale.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  LocaleResponse,
} from '../../../types/localization';

const BASE_PATH = '/localization';

/**
 * Get locale
 * Retrieves a locale definition by ID or BCP 47 code.
 */
export async function GetLocale(
  locale_id: string,
  options?: RequestOptions
): Promise<LocaleResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/localization/locales/:locale_id`;
  requestPath = requestPath.replace(':locale_id', encodeURIComponent(locale_id));
  const requestOptions = options;
  return client.get<LocaleResponse>(requestPath, { ...requestOptions });
}
